export default {
  pictureInPictureToggle: false,
  fullscreenToggle: false,
  progressControl: false,
  playToggle: false,
  remainingTimeDisplay: false,
  seekToLive: false,
  volumePanel: false,
};
